import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Breadcrumb } from 'antd';
import Footer from '../Footer';
import './AboutUs.css';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' });
  const { t, i18n } = useTranslation();

  return (
    <HelmetProvider>
      <div className="wrapper_CTL pages">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{t("Professional Inspectors - Découvrez notre Engagement, Mission et Valeurs")}</title>
          <meta
            name="description"
            content={t("Explorez notre vision, mission, et valeurs chez Professional Inspectors. Notre engagement et professionnalisme visent à anticiper les besoins de nos clients et à innover pour mieux les servir. Faites confiance à notre inspection indépendante pour garantir la conformité et la qualité à chaque étape de vos projets.")}
          />
          <meta
            name="keywords"
            content={t("Professional Inspectors, inspection indépendante, vision, mission, valeurs, engagement, professionnalisme, qualité, conformité, innovation")}
          />
        </Helmet>

        <Breadcrumb separator=">">
          <Breadcrumb.Item href="/">{t('Acceuil')}</Breadcrumb.Item>
          <Breadcrumb.Item>{t('A Propos')}</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container_1">
          <AboutSection
            title={t('Vision')}
            text={t('Notre engagement, notre professionnalisme sont à la disposition de nos clients pour anticiper leur besoin et leur permettre d\'obtenir un coup de pouce dans leur parcours de réalisation de leurs objectifs. Notre passion est de porter notre organisme au rang de leader pour constituer un point de référence, reconnu sur le marché, en mesure d\'innover pour mieux servir.')}
            image="images/businessman-big-office.jpg"
            invertPosition={isDesktopOrLaptop} 
          />

          <AboutSection
            title={t('Mission')}
            text={t('Que vous mettiez en place des produits ou des projets, vous avez besoin d\'une inspection indépendante de confiance pour garantir la conformité aux obligations légales et à vos propres normes de qualité à chaque stage de la production ou de l\'exploitation. Notre gamme complète de services d\'inspection vous aide à réduire les risques, promouvoir votre image de marque et fructifier vos équipements et vos installations.')}
            image="images/mission.jpg"
            invertPosition={false}
          />

          <AboutSection
           title={t('Nos valeurs')}
           text={t('A travers notre passion pour notre métier, nous nous engageons à :')}
           listItems={[
             t("Assurer la transparence et la qualité à nos partenaires en cohérence avec les standards internationaux."),
             t("Etre à l’écoute de nos clients pour aller au-delà de leurs attentes et exigences."),
             t("Assurer le professionnalisme, objectivité, impartialité et indépendance de notre effectif conformément à notre code de conduite."),
             t("Identifier les alternatives qui permettent la protection de l’environnement et la prévention de la pollution."),
           ]}
            image="images/val.jpg"
            invertPosition={isDesktopOrLaptop}
          />
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

const AboutSection = ({ title, text, listItems, image, invertPosition }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <motion.div
      className={`row about ${invertPosition ? 'invert' : ''}`}
      variants={sectionVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      ref={ref}
    >
      <div className="col-sm-6">
        {invertPosition ? (
          <>
            <h1>{title}</h1>
            <p className="approach">{text}</p>
            {listItems && (
              <ul>
                {listItems.map((item, index) => (
                  <p key={index}>&#8226; {item}</p>
                ))}
              </ul>
            )}
          </>
        ) : (
          <div className="pic">
            <img
              src={image}
              className="img-fluid intro_image"
              alt={title}
              loading="lazy"  // Ajoutez l'attribut de chargement paresseux ici
            />
          </div>
        )}
      </div>
      <div className="col-sm-6">
        {invertPosition ? (
          <div className="pic">
            <img
              src={image}
              className="img-fluid intro_image"
              alt={title}
              loading="lazy"  // Ajoutez l'attribut de chargement paresseux ici
            />
          </div>
        ) : (
          <>
            <h1>{title}</h1>
            <p className="approach">{text}</p>
            {listItems && (
              <ul>
                {listItems.map((item, index) => (
                  <li key={index}>&#8226; {item}</li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </motion.div>
  );
};

export default AboutUs;
